import { Platform } from 'react-native';
import { storage } from '../../../storage';

export const getStorageItem = (itemName: string) => {
  const storageItem =
    Platform.OS === ('android' || 'ios')
      ? //@ts-ignore
        storage.cache?.[itemName]?.rawData
      : //@ts-ignore
        JSON.parse(window.localStorage.getItem(itemName))?.rawData;

  return storageItem;
};

export const saveOnStorage = (key: string, data: any) => {
  storage.save({
    key,
    data,
  });
};

export const getCookie = (cookieString: string, key: string) => {
  if (cookieString) {
    const allCookies = cookieString.split('; ');
    const targetCookie = allCookies.find((cookie) => cookie.includes(key));
    if (targetCookie) {
      const [_, value] = targetCookie.split('=');
      return value;
    }
  }
  return null;
};
